<template>
  <div class="original-exam">
    <v-base-card>
      <template v-slot:heading>
        プリセットテスト作成条件
      </template>

      <template v-slot:content>
        <p class="ml-2 mb-0 attention__message">最初から解答重複の注意が出ることがありますが，意図の違う出題であり，弊社基準では許容としております。<br>お心懸かりございましたらご確認ください。</p>
        <p class="ml-2 mt-3 mb-0 attention__message">「テスト時期」は標準的な学習進度で問題登録しています。<br>進度が合わない場合は、他を選択してお試しください。また、二期制は選択できませんので、三期制の中からご選択ください。</p>
        <p class="ml-2 mt-3 mb-0 attention__message">※「保健・体育」については，「かんたん！テスト作成」の設定はございません。各学校の実情に合わせて，「②じっくり！オリジナルテスト作成」より作成願います。</p>
        <v-container fluid>
          <v-row>
            <v-col cols="2">
              <v-select
                class="select"
                v-model="selectedGrade"
                :items="grades"
                item-text="name"
                item-value="id"
                label="学年"
                :disabled="isSelectedSkillSubject"
              ></v-select>
            </v-col>
            <v-col cols="2">
              <v-select
                class="select"
                v-model="selectedSubject"
                :items="subjects"
                item-text="name"
                item-value="id"
                label="教科"
              ></v-select>
            </v-col>
            <v-col cols="2">
              <v-select
                class="select"
                :disabled="!selectedSubject"
                v-model="selectedTextbook"
                :items="textbooks[selectedSubject]"
                item-text="name"
                item-value="id"
                label="教科書"
              ></v-select>
            </v-col>
            <v-col lg=2 md="3" sm=3>
              <v-select
                class="select"
                v-model="selectedExam"
                :items="exams"
                item-text="name"
                item-value="id"
                label="テスト時期"
                :disabled="isSelectedSkillSubject"
              ></v-select>
            </v-col>
            <v-col cols="1">
              <v-btn class="mt-2" color="secondary" @click="search" :disabled="disabled">絞込み</v-btn>
            </v-col>
          </v-row>
          <v-row v-if="presets.length != 0" class="px-0">
            <v-col lg="3" md="3" sm="4" v-for="preset in presets" :key="preset.id">
              <v-clickable-card
                elevation="2"
                style="max-width: 250px"
                :detail="preset.detail"
                @click="settingMaxPoint(preset)"
              >
                <template v-slot:heading>
                  <v-list-item-content>
                    <v-list-item-title class="text-center heading">{{preset.title}}</v-list-item-title>
                  </v-list-item-content>
                </template>

                <template v-slot:content>
                  <v-simple-table dense>
                    <template v-slot:default>
                      <tbody>
                        <tr>
                          <th class="text-center pl-1 py-2 th_top">学年</th>
                          <td class="text-center pl-1 py-2 td_top">{{ preset.grade || 'ー' }}</td>
                        </tr>
                        <tr>
                          <th class="text-center pl-1 py-2">教科</th>
                          <td class="text-center pl-1 py-2">
                            {{ preset.subject }}
                          </td>
                        </tr>
                        <tr>
                          <th class="text-center pl-1 py-2">教科書</th>
                          <td class="text-center pl-1 py-2" v-html="preset.textbook" />
                        </tr>
                        <tr>
                          <th class="text-center pl-1 py-2">範囲</th>
                          <td class="text-center pl-1 py-2" v-html="preset.range" />
                        </tr>
                        <tr>
                          <th class="text-center pl-1 py-2 th_bottom">設問数</th>
                          <td class="text-center pl-1 py-2 td_bottom" v-html="preset.questionNum" />
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </template>
              </v-clickable-card>
            </v-col>
          </v-row>
        </v-container>
      </template>
    </v-base-card>

    <!-- 配点設定用のモーダル -->
    <v-dialog v-model="dialog" persistent max-width="400px">
      <v-card>
        <v-toolbar
          class="title"
        >配点を選択してください</v-toolbar>
        <!-- <v-card-title>
          <span class="headline">配点を選択してください</span>
        </v-card-title> -->
        <v-card-text>
          <v-choice-max-point/>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" class="dialog-Button" text @click="dialogCancel">キャンセル</v-btn>
          <v-btn color="blue darken-1" class="dialog-Button" text @click="dialogNext" :disabled="!nextFlg">次へ</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import VBaseCard from '@/components/molecules/BaseCard'
import VClickableCard from '@/components/molecules/ClickableCard'
import VChoiceMaxPoint from '@/components/molecules/ChoiceMaxPoint'
import config from '../../config'

export default {
  components: {
    VBaseCard,
    VClickableCard,
    VChoiceMaxPoint,
  },

  data: () => ({
    selectedTextbook: '',
    selectedExam: '',
    presets: [],
    dialog: false,
    selectedPreset: []
  }),

  computed: {
    selectedGrade: {
      get() {
        return this.$store.state.top.selectedGrade?.id
      },
      set(value) {
        this.$store.commit('setSelectedGrade', {
          grade: this.grades
            ? this.grades.find(grade => grade.id === value)
            : null
        })
      }
    },
    selectedSubject: {
      get() {
        return this.$store.state.top.selectedSubject?.id;
      },
      set(value) {
        this.$store.commit('setSelectedSubject', {
          subject: this.subjects
            ? this.subjects.find(subject => subject.id === value)
            : null
        })
      }
    },
    disabled() {
      if (this.isSelectedSkillSubject){
        return (this.selectedSubject === '' || this.selectedTextbook === '')
      } else {
        return (this.selectedGrade === '' || this.selectedSubject === '' || this.selectedTextbook === '' || this.selectedExam === '')
      }

    },
    grades() {
      // アカウントごとの担当学年を返す
      const accountGradeIds = this.$store.state.top.subjectTeachers.map(subjectTeacher => subjectTeacher.grade.id)
      return this.$store.state.master.allGrades.filter(grade => accountGradeIds.includes(grade.id))
    },
    subjects() {
      // アカウントごとの担当教科を返す
      const accountSubjectIds = this.$store.state.top.subjectTeachers.map(subjectTeacher => subjectTeacher.subject.id)
      return this.$store.state.master.allSubjects.filter(subject => subject.ancestryDepth === 0 && accountSubjectIds.includes(subject.id))
    },
    textbooks() {
      const textbooks = {}
      this.$store.state.master.allSubjects.filter(x => x.ancestryDepth == 0).map(y => {
        textbooks[y.id] = y.publishers
      })
      return textbooks
    },
    exams() {
      return this.$store.state.master.allPeriods
    },
    examsAlert() {
      return this.selectedExam && 4<this.selectedExam ? '現在登録されている問題はありません' : ''
    },
    nextFlg() {
      return this.$store.state.top.selectedMaxPoint && !this.$store.state.top.selectedMaxPoint.match(/[^0-9]/)
    },
    isSelectedSkillSubject() {
      const subject = this.subjects.find(subject => subject.id === this.selectedSubject)
      return config.skillSubjects.includes(subject.code)
    }
  },

  watch: {
    isSelectedSkillSubject(newValue, oldValue) {
      if (newValue) {
        this.selectedGrade = ''
        this.selectedExam = ''
      } else if (oldValue) {
        this.selectedGrade = 1
        this.selectedExam = ''
      }
    }
  },

  methods: {
    async search() {
      this.$app.$refs.loading.open({message: '検索中'})
      this.presets = []
      // 検索API実行
      let params = ''
      // 技能教科が選択されてるときは学年とテスト時期をパラめテータに含めない
      if (this.isSelectedSkillSubject) {
        params = `?q[subject_id_eq]=${this.selectedSubject}&q[publisher_id_eq]=${this.selectedTextbook}`
      } else {
        params = `?q[grade_id_eq]=${this.selectedGrade}&q[subject_id_eq]=${this.selectedSubject}&q[publisher_id_eq]=${this.selectedTextbook}&q[period_id_eq]=${this.selectedExam}`
      }
      const res = await this.$axios('/api/v1/teacher/presets' + params)

      // プリセットが見つからなかったらその旨表示
      if (!res.data.length) {
        this.$toasted.global.error({ message: 'プリセットがありません' })
        return false
      }

      res.data.forEach(item => {
        this.presets.push(this.$store.getters['sheet/convertPresetData'](item))
      })

      this.$app.$refs.loading.close({})
    },

    settingMaxPoint(preset) {
      this.selectedPreset = preset
      this.dialogOpen()
    },
    dialogOpen() {
      this.dialog = true
    },
    dialogCancel() {
      this.dialog = false
    },
    dialogNext() {
      this.dialog = false
      this.showDetail(this.selectedPreset)
    },

    async showDetail(preset) {
      this.$app.$refs.loading.open({message: '処理中です。少々お待ちください。'})
      const subject = this.$store.state.master.allSubjects.find(x => x.id == this.selectedSubject)
      this.$store.commit('setSelectedSubject', { subject: subject } )
      await this.$store.dispatch('initializeAllConditions')
      preset.details.forEach(detail => {
        // 社会と技能教科の場合は分野をセット
        if (config.hasOptionSubjects.includes(preset.subjectCode)) {
          const option = this.$store.state.master.allSubjects.find(x => x.code === detail.subject_code)
          this.$store.commit('addSelectedShakaiOptions', { option: option })
        }

        this.$store.commit(
          'setCurrentSubjectCondition',
          {
            currentSubjectCondition: this.$store.state.top.allConditions
              .find(condition => condition.code === detail.subject_code)
          }
        )

        const publisher = subject.publishers.find(x => x.name == detail.publisher_name)
        const grade = this.$store.state.master.allGrades.find(x => x.name == preset.grade)
        const ranges = preset.rangeData.find(x => x.subjectCode === detail.subject_code)?.ranges || []

        this.$store.commit('setSelectedGrade', { grade: grade } )
        this.$store.commit('changeCurrentSubjectCondition', {
          selectedPublisher: publisher,
          publisherPages: ranges.map(range => ({ start: String(range[0]), end: String(range[1]) })),
          questionNum: String(detail.question_cnt)
        })
      })

      const params = {"preset_id": preset.id, "subject_id": this.selectedSubject, "selected_max_point": this.$store.state.top.selectedMaxPoint, "restartSheets": null}
      await this.$store.dispatch('sheet/getSheetContents', params)
      //問題作成再開処理用にプリセットIDを保存
      this.$store.commit('sheet/setSheetSearchCondition', {
        sheetSearchCondition: params
      })
      this.$app.$refs.loading.close()
      // 画面遷移
      this.$router.push('/teacher/change')
    }
  }
}
</script>

<style lang="stylus" scoped>
th
  width 80px
  background-color #efefef
  font-size 12px !important

td
  background-color white !important;
  font-size 12px !important

.th
  &_top
    border-top #3872b0 2px solid
  &_bottom
    border-bottom #d6d6d6 1px solid

.td
  &_top
    border-top #d6d6d6 2px solid
  &_bottom
    border-bottom #d6d6d6 1px solid

.select
  font-size: 14px !important;

.heading
  font-size: 14px !important;

.exams-alert
  color:#FF0000;
  font-weight:bold;

.attention__message
  font-size 12px
  color #FF0000

.title
  justify-content center
  background-color: #2a5594 !important
  color white

</style>
